<script>
import BaseController from '@/controllers/BaseController'
import Storage from '@/utils/storage'

export default {
  name: 'FormController',
  extends: BaseController,
  // beforeRouteEnter: function (to, from, next) {
  //    if (!to.params.__isValid && to.meta.parent) {
  //     // this.$store.dispatch('tagsView/delView', to)
  //     next(to.meta.parent)
  //    }
  //    else {
  //      next()
  //    }
  // },
  created: function () {
    if (!this.$route.params.__isValid) {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.returnPage()
    }
    if (this.pageControllerName) {
      let data = Storage.getItem(this.getSessionKey('List'))
      if (data) {
        this.listData = data
      }
    }
    this.createFormData()
    this.afterCreateFormData()
  },
  data: function () {
    return {
      isEdit: false,
      form: {},
      forceReload: false
    }
  },
  asyncComputed: {
    record: {
      lazy: true,
      get: function () {
        if (this.$route.params.__isValid && !this.$route.params.create) {
          return this.getRecord(this.forceReload)
        }
        return new Promise(resolve => resolve({}))
      },
      default: {}
    }
  },
  computed: {
    hasPrev: function () {
      if (!this.$route.params) return false
      if (!this.$route.params.list) return false
      let idx = this.$route.params.list.findIndex(item => item.id === this.$route.params.recordId)
      if (idx === -1) return false
      return idx > 0
    },
    hasNext: function () {
      if (!this.$route.params) return false
      if (!this.$route.params.list) return false
      let idx = this.$route.params.list.findIndex(item => item.id === this.$route.params.recordId)
      if (idx === -1) return false
      return idx < (this.$route.params.list.length - 1)
    }
  },
  watch: {
    record: function () {
      this.createFormData()
    }
  },
  methods: {
    reload: function () {
      this.forceReload = !this.forceReload
    },
    createFormData: function () {
    },
    afterCreateFormData: function () {
    },
    initFormFieldRec: function (form, field, rec, def) {
      let arr = typeof field === 'string' && field ? field.split('.') : []
      if (arr.length > 1) {
        let f = arr.splice(0, 1)[0]
        if (!form[f]) this.$set(form, f, {})
        this.initFormFieldRec(form[f], arr.join('.'), rec && rec[f] ? rec[f] : null, def)
      }
      else {
        if (rec && rec[field] !== undefined && rec[field] !== null) {
          if (Array.isArray(rec[field])) {
            this.$set(form, field, [])
            for (let i = 0; i < rec[field].length; i++) {
              form[field].push({})
              this.initFormFieldRec(form[field], i, rec[field], null)
            }
          }
          else if (typeof rec[field] === 'object') {
            this.$set(form, field, {})
            for (let i in rec[field]) {
              this.initFormFieldRec(form[field], i, rec[field], null)
            }
          }
          else {
            this.$set(form, field, rec[field])
          }
        }
        else {
          this.$set(form, field, def)
        }
      }
    },
    initFormField: function (frm, field, def) {
      this.initFormFieldRec(frm, field, this.record, def)
    },
    fetchRecord: function (api, condlist, field, p_all) {
      return new Promise((resolve, reject) => {
        this.$tango[api](condlist).then(rep => {
          if (rep.resultCode === 0 && rep[field] && rep[field].length) {
            if (typeof p_all !== 'undefined' && p_all) {
              resolve(rep[field])
            }
            else {
              resolve(rep[field][0])
            }
          }
          else {
            throw new Error(this.$t('reading request failed!') + ' ' + this.$t(this.resultMessage[rep.resultCode]))
          }
        }).catch(err => {
          this.$message({
            type: 'error',
            message: err.message
          })
          reject(err)
        })
      })
    },
    getRecord: function () {
      return new Promise(resolve => resolve({}))
    },
    navInitPage: function () {
      this.isEdit = false
    },
    goPrevNext: function (idx) {
      this.navInitPage()
      let routePage = {
        name: this.$route.name,
        params: { recordId: this.$route.params.list[idx].id, recordLabel: this.$route.params.list[idx].label },
        fullpath: this.$route.fullpath,
        path: this.$route.path
      }
      this.viewEdit(routePage, false, true, false, this.$route.params.list)
    },
    goPrev: function () {
      if (!this.$route.params) return false
      let idx = this.$route.params.list.findIndex(item => item.id === this.$route.params.recordId)
      idx--
      if (idx >= 0) this.goPrevNext(idx)
    },
    goNext: function () {
      if (!this.$route.params) return false
      let idx = this.$route.params.list.findIndex(item => item.id === this.$route.params.recordId)
      if (idx === -1) return false
      idx++
      if (idx < this.$route.params.list.length) this.goPrevNext(idx)
    },
    back () {
    },
    setEdit (flag) {
      this.isEdit = flag
    },
    prevNext: function (direction) {
      if (!this.$route.params.__isValid || this.$route.params.create) return
      let idx = this.$route.params.$index + direction
      if (idx < 0) return
      if (idx >= this.$route.params.list.length) return
      let params = Object.assign({
        __isValid: 1,
        isReadOnly: true,
        isCopy: false,
        create: false,
        list: this.$route.params.list
      }, this.$route.params.list[idx])
      let name = this.$route.name
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ path: '/next' }).then(() => { return this.$router.push({ name: name, params: params }) }).catch(() => {})
    },
    prevRecord: function () {
      this.prevNext(-1)
    },
    nextRecord: function () {
      this.prevNext(1)
    },
    returnDetail () {
      this.isReadOnly = !this.isReadOnly
    },
    reloadForm: function (rep) {
      let list = []
      if (this.$route.params.list) list = list.concat(this.$route.params.list)
      let idx = this.$route.params.$index
      if (this.$route.params.create || this.$route.params.isCopy) {
        list.push(rep)
        idx = list.length - 1
        rep.$index = idx
      }
      let params = Object.assign({
        __isValid: 1,
        isReadOnly: true,
        isCopy: false,
        create: false,
        list: list
      }, list[idx])
      let name = this.$route.name
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ path: '/next' }).then(() => { return this.$router.push({ name: name, params: params }) }).catch(() => {})
    },
    submit () {
    },
    resetForm () {
      this.$refs['form'].resetFields()
      this.$nextTick().then(() => {
        this.createFormData()
      })
    }
  }
}
</script>
